howspace.widgets.heading = (() => {
    'use strict';

    const SIZE_CLASSES = ['heading-size-s', 'heading-size-m', 'heading-size-l', 'heading-size-xl'];
    const ALIGN_CLASSES = ['heading-align-left', 'heading-align-center', 'heading-align-right'];
    const STYLE_CLASSES = {bold: 'is-bold', italic: 'is-italic'};

    const getEditor = widget => widget.find('.heading-editor');

    const getPreview = widget => widget.find('.heading-preview .howspace-heading');

    const isSizeOverridden = widget => getEditor(widget).data('size-overridden') === true;

    const replaceTags = (text, resolvedTags) => {
        let result = text;
        Object.entries(resolvedTags).forEach(([tag, value]) => {
            result = result.split(tag).join(value);
        });
        return result;
    };

    const updateText = widget => {
        const text = widget.find('input.heading-text-input').val() || '';
        const resolvedTags = getEditor(widget).data('resolved-tags') || {};
        // textContent keeps the preview from ever rendering the typed text as markup.
        getPreview(widget).find('.howspace-heading-text')[0].textContent = replaceTags(text, resolvedTags);
    };

    const updateSize = widget => {
        const size = widget.find('.heading-size input:checked').val();
        getPreview(widget).removeClass(SIZE_CLASSES.join(' ')).addClass('heading-size-' + size);
    };

    const updateAlign = widget => {
        const align = widget.find('.heading-align input:checked').val();
        getPreview(widget).removeClass(ALIGN_CLASSES.join(' ')).addClass('heading-align-' + align);
    };

    const updateStyles = widget => {
        Object.entries(STYLE_CLASSES).forEach(([name, className]) => {
            const checked = widget.find(`.heading-style input[name="${name}"]`).prop('checked');
            getPreview(widget).toggleClass(className, checked);
        });
    };

    const loadFont = (widget, font) => {
        const fontFiles = getEditor(widget).data('font-files') || {};
        const href = fontFiles[font];
        if (!href || document.querySelector(`link[rel="stylesheet"][href="${CSS.escape(href)}"]`)) {
            return;
        }
        $('<link rel="stylesheet">').attr('href', href).appendTo('head');
    };

    // The font menu lists every font in itself, so they are all loaded the first time it opens.
    const loadAllFonts = widget => {
        Object.keys(getEditor(widget).data('font-files') || {}).forEach(font => loadFont(widget, font));
    };

    const updateFont = (widget, select) => {
        const font = howspace.components.searchableSelect.getValue(select);
        select.find('[data-toggle="dropdown"]').css('font-family',
            font ? `"${font}"` : 'var(--howspace-header-font-family)');

        const preview = getPreview(widget)[0];
        if (!font) {
            preview.style.removeProperty('--heading-font-family');
            return;
        }
        loadFont(widget, font);
        preview.style.setProperty('--heading-font-family', `"${font}"`);
    };

    const setPreviewColor = (widget, color) => {
        const preview = getPreview(widget)[0];
        if (!color) {
            preview.style.removeProperty('--heading-color');
            return;
        }
        preview.style.setProperty('--heading-color', color);
    };

    const getColorPicker = widget => widget.find('.heading-color .howspace-color-picker');

    // With no colour of its own the heading follows the theme, so the swatch shows the colour the preview renders in.
    const showThemeColorOnSwatch = widget => {
        const themeColor = getComputedStyle(getPreview(widget)[0]).color;
        getColorPicker(widget).find('button.color-picker-toggle').css({'color': themeColor, 'background-color': themeColor});
    };

    const resetColor = widget => {
        const colorPicker = getColorPicker(widget);
        colorPicker.find('.howspace-color-picker-input').val('');
        colorPicker.dataAndAttr('color', '');
        setPreviewColor(widget, '');
        showThemeColorOnSwatch(widget);
    };

    const insertTag = (widget, tag) => {
        const input = widget.find('input.heading-text-input');
        const element = input[0];
        const value = input.val() || '';
        const start = element.selectionStart ?? value.length;
        const end = element.selectionEnd ?? value.length;
        input.val(value.slice(0, start) + tag + value.slice(end));
        element.focus();
        element.setSelectionRange(start + tag.length, start + tag.length);
        updateText(widget);
    };

    const onLevelChange = widget => {
        if (isSizeOverridden(widget)) {
            return;
        }
        const level = widget.find('select[name="heading_level"]').val();
        const defaultSizes = getEditor(widget).data('level-default-sizes') || {};
        widget.find(`.heading-size input[value="${defaultSizes[level]}"]`).prop('checked', true);
        updateSize(widget);
    };

    return {
        initEdit: widget => {
            widget.on('input', '.heading-text-input', () => updateText(widget));

            widget.on('change', '.heading-tag-select', function () {
                const tag = $(this).val();
                if (tag) {
                    insertTag(widget, tag);
                }
                this.selectedIndex = 0;
            });

            widget.on('change', 'select[name="heading_level"]', () => onLevelChange(widget));

            widget.on('change', '.heading-size input', () => {
                getEditor(widget).dataAndAttr('size-overridden', true);
                updateSize(widget);
            });

            widget.on('change', '.heading-align input', () => updateAlign(widget));

            widget.on('change', '.heading-style input', () => updateStyles(widget));

            widget.on(howspace.components.searchableSelect.CHANGE, '.heading-font', e => {
                updateFont(widget, $(e.currentTarget));
            });
            widget.one(howspace.popover.POPOVER_OPENED, '.heading-font', () => loadAllFonts(widget));

            widget.on(howspace.components.colorPicker.COLOR_PICKER_PICK, e => {
                setPreviewColor(widget, e.detail.color.hsl);
            });

            widget.on('click', '.heading-color-reset', () => resetColor(widget));

            const colorPicker = getColorPicker(widget);
            if (!colorPicker.find('.howspace-color-picker-input').val()) {
                if (colorPicker.hasClass('color-picker-initialized')) {
                    showThemeColorOnSwatch(widget);
                } else {
                    colorPicker.one(howspace.components.colorPicker.COLOR_PICKER_INITIALIZED, () => showThemeColorOnSwatch(widget));
                }
            }
        },
        destroyEdit: widget => {
            // Event handlers are removed with the widget.
        },
        save: (widget, dataPayload) => {
            // A size the user never picked follows the heading level, so it is stored as no size at all.
            if (!isSizeOverridden(widget)) {
                dataPayload.font_size = '';
            }
            return dataPayload;
        }
    };
})();
